import React, { useState, useEffect } from 'react'
import { clientsService } from '../../_services/clients.service'
import { NumberInput, NUMBER_FORMAT_LATIN } from 'react-hichestan-numberinput'
import InputMask from 'react-input-mask';
import BankSelect from '../Shared/BankSelect'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import ProvinceSelect from '../Shared/ProvinceSelect'
import CitySelect from '../Shared/CitySelect'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const initialData = {
  name: ''
}

export default function ClientFormDialog(props) {
  const [loading, setLoading] = useState(false)
  const [dialogShow, setDialogShow] = useState(props.show || false)
  const [data, setData] = useState(initialData)
  const [id, setId] = useState(props.id)

  useEffect(() => {

    // setData(initialData)

    if (props.id) {
      setId(props.id)
      getData()
    } else {
      setData(initialData)
    }
    setDialogShow(props.show)

  }, [props.show, props.id])

  const getData = () => {
    setLoading(true)
    clientsService.getById(props.id)
      .then((res) => {
        console.log(res.data)
        let data_ = res.data;
        data_["provinceId"] = data_.city.provinceId
        setData(data_)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      });
  }

  const handleSubmit = (values) => {
    setLoading(true)
    // console.log(JSON.stringify(values));

    if (values.id) {

      clientsService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          toastr.success('ویرایش طرف حساب', 'طرف حساب "' + values.name + '" با موفقیت ویرایش شد');
          props.handleModalHideAndReload()

        })
        .catch((error) => {
          console.log(error)
        });

    } else {
      console.log(JSON.stringify(values));
      clientsService.add(JSON.stringify(values))
        .then((res) => {

          toastr.success('ثبت طرف حساب جدید', 'طرف حساب "' + res.data.name + '" با موفقیت ثبت شد');
          props.handleModalHideAndReload()

        })
        .catch((error) => {
          console.log(error)
        });

    }
  }

  const ValidationSchema = Yup.object().shape({
    name: Yup.string().trim().nullable().required('عنوان طرف حساب'),
  })

  return (

    <Dialog
      open={dialogShow}
      onClose={props.handleModalHide}
      TransitionComponent={Transition}
      scroll={'paper'}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description">
      <DialogTitle>
        <Fab color="secondary" aria-label="refresh" size="small" onClick={() => props.handleModalHide()} className="modal-close-btn">
          <MdClose size="20px" />
        </Fab>
        <span style={{ marginRight: 10 }}></span>
      </DialogTitle>
      <DialogContent dividers={true}>

        <Formik
          initialValues={data}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            // // console.log(values);
            handleSubmit(values)
          }}
          validationSchema={ValidationSchema}
        >
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
            } = props;
            return (

              <div className="row" style={{ position: "relative" }}>
                <div className="col-md-12">
                  <form onSubmit={handleSubmit}>

                    <div className="row">
                      <div className="form-inline">

                        <div className="col-md-4 col-sm-12">
                          <label>عنوان طرف حساب</label>
                          <Field type="text"
                            autoFocus
                            name="name"
                            className={
                              getIn(errors, "name") &&
                                getIn(touched, "name")
                                ? "text-input has-error "
                                : "text-input required "
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="name" />
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <label>تلفن</label>
                          <NumberInput autoFocus type='tel' className="latin-number" maxLength="11" name="tel"
                            autoComplete="off" numberFormat={NUMBER_FORMAT_LATIN}
                            value={values.tel}
                            maxLength={11}

                            // placeholder="شماره موبایل خود را وارد نمایید"
                            onChange={e => setFieldValue("tel", e.target.value)}
                            className={
                              getIn(errors, "address") &&
                                getIn(touched, "address")
                                ? "text-input has-error ltr"
                                : "text-input required ltr"
                            }
                          />

                          <ErrorMessage component={ErrorPopUp} name="tel" />
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <label>موبایل</label>
                          <NumberInput autoFocus type='tel' className="latin-number" maxLength="11" name="mobile"
                            autoComplete="off" numberFormat={NUMBER_FORMAT_LATIN}
                            value={values.mobile}
                            maxLength={11}

                            // placeholder="شماره موبایل خود را وارد نمایید"
                            onChange={e => setFieldValue("mobile", e.target.value)}
                            className={
                              getIn(errors, "address") &&
                                getIn(touched, "address")
                                ? "text-input has-error ltr"
                                : "text-input required ltr"
                            }
                          />

                          <ErrorMessage component={ErrorPopUp} name="mobile" />
                        </div>

                        <div className="clearfix form-row"></div>

                        <div className="col-md-6">
                          <label className="rtl">استان</label>
                          <ProvinceSelect
                            required
                            defaultValue={values.provinceId}
                            onChange={(val) => {
                              setFieldValue('provinceId', val.value);
                            }}
                          />
                          <ErrorMessage component={ErrorPopUp} name="provinceId" />
                        </div>

                        <div className="col-md-6">
                          <label className="rtl">شهر</label>
                          <CitySelect
                            required
                            defaultValue={values.cityId}
                            provinceId={values.provinceId}
                            onChange={(val) => {
                              setFieldValue('cityId', val.value);
                            }}
                          />
                          <ErrorMessage component={ErrorPopUp} name="cityId" />
                        </div>

                        <div className="clearfix form-row"></div>

                        <div className="col-md-12 col-sm-12">
                          <label>آدرس</label>
                          <Field type="text"
                            autoFocus
                            name="address"
                            className={
                              getIn(errors, "address") &&
                                getIn(touched, "address")
                                ? "text-input has-error "
                                : "text-input required "
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="address" />
                        </div>

                        <div className="clearfix form-row"></div>

                        <div className="col-md-12">
                          <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}>
                            {isSubmitting ?
                              <AiOutlineLoading className="mdi-spin" size="22px" />
                              :
                              <AiOutlineSave size="22px" />
                            }ذخیره</button>
                        </div>
                        <div className="clearfix form-row"></div>

                      </div>
                    </div>


                  </form>

                  {loading ? <Loading /> : ''}
                </div>
              </div>

            );
          }}
        </Formik>

      </DialogContent>
    </Dialog >

  )
}